import React from 'react';
import './toast.css';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ToolType, toolTypeToPath } from '../../utils/types';
import { useAppDispatch } from '../../app/hooks';
import { setSelectedTool } from '../../app-slice';

interface NotificationToastProps {
  messages: string[];
}

function NotificationList({ items }: { items: string[] }) {
  return (
    <ul>
      {items.map((item, index) => (
        <li key={index}>{item}</li>
      ))}
    </ul>
  );
}
const NotificationToast: React.FC<NotificationToastProps> = ({ messages }) => {
  const navigate = useNavigate();
  const handleViewLogClick = (path: string) => {
    toast.dismiss();
    navigate(path);
  };
  const dispatch = useAppDispatch();

  return (
    <div>
      <NotificationList items={messages} />
      <button
        className="toast-button"
        onClick={() => {
          handleViewLogClick(toolTypeToPath[ToolType.VIEW_NOTIFICATIONS]);
          dispatch(setSelectedTool(ToolType.VIEW_NOTIFICATIONS));
        }}
      >
        View all notifications
      </button>
    </div>
  );
};

export default NotificationToast;
